import PropTypes from 'prop-types';

export default PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    is_default: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    answer_desired: PropTypes.any,
    fields_to_verify: PropTypes.arrayOf(PropTypes.any)
});



// WEBPACK FOOTER //
// ./execution/v2/panels/smart_questions_panel/shared_proptypes/smart_question.js